<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Driver Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Driver Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <form @submit.prevent="filterData">
                    <div class="d-flex justify-content-center mt-2 mb-2">
                        <div class="col-xl-4 col-md-4">
                            <label>Start date</label><br/>
                            <input type="date" v-model="reportFilter.start_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>End date</label><br/>
                            <input type="date" v-model="reportFilter.end_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>&nbsp;</label><br/>
                            <button type="submit" class="btn btn-primary">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </form>

                <div class="card-body">
                    <div class="row">
                        <div class="col-12 p-3">
                            <h4 class="text-center">Total Drivers ({{ total_drivers }})</h4>
                            <div class="chart-wrapper mx-auto">
                                <PieChart :chart-data="pieData" :options="pieOptions"/>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="text-center">
                    <b> {{ period }}</b>
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/inertia-vue';
import PieChart from "../../Shared/PieChart.vue";
import {Doughnut} from "vue-chartjs/legacy";

export default {
    metaInfo: {title: 'Driver Reports'},
    props: ['totalDrivers', 'driverStats'],
    layout: Layout,
    name: 'DriverReport',
    components: {
        Doughnut,
        PieChart,
        Link,
    },
    mixins: [],
    data: () => ({
        pieOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        reportFilter : {
            start_date: '',
            end_date: ''
        },
        period: '',
        pieData: {
            labels: [],
            datasets: []
        },
        total_drivers: '',
        excelData: {},
    }),
    mounted() {
        let data = this.driverStats.data;
        this.period = this.driverStats.period;

        const labels = Object.keys(data).map(key => key);
        const values = Object.keys(data).map(key => data[key]);
        const colors =this.pieColor();

        this.pieData = this.pieThumbprint(labels, values, colors);
        this.total_drivers = this.totalDrivers
    },

    methods: {
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        async filterData() {
            try {
                let results = await axios.get(route("admin.reports.drivers"), {
                    params: {
                        start_date: this.reportFilter.start_date,
                        end_date: this.reportFilter.end_date,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });


                let data = results.data.driverStats.data;

                const labels = Object.keys(data).map(key => key);
                const values = Object.keys(data).map(key => data[key]);
                const colors = this.pieColor();

                this.pieData = this.pieThumbprint(labels, values, colors);
                this.period = results.data.driverStats.period
                this.total_drivers = results.data.totalDrivers
            } catch (e) {
                console.log(e);
            }
        },

        pieThumbprint(labels, data, backgroundColor) {
            return {
                labels,
                datasets: [
                    {
                        backgroundColor,
                        data
                    }
                ]
            }
        },

        randomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        },

        pieColor() {
            return ['#8E50EB', '#FFA87D'];
        },

        async resetFilter() {
            this.reportFilter = {
                start_date: '',
                end_date: ''
            }

            await this.filterData();
        },
    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Device', 'Total']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                rows.push([key, this.excelData[key]]);
            }

            return rows;
        }
    }
}
</script>
<style>
.chart-wrapper {
    width: 350px;      /* desired width */
    height: 350px;     /* desired height */
    display: flex;
    justify-content: center;
    align-items: center;
}
.chart-wrapper canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
